import React, { useEffect, useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { Button, Container, Form, Image, Label, Message, Transition } from "semantic-ui-react"
import { endpoint } from "../../api/http"
import { Images } from '../../assets/assets'
import Panel from "../../components/shared/Panel"
import PasswordInput from "../../components/shared/PasswordInput"
import { useTextResources } from "../../language"
import { useLoader } from "../../hooks/useLoader"
export const LoginPage = () => {
    const text = useTextResources()
    const loader = useLoader()
    const [visible, setVisible] = useState(false)
    const [forgot, setForgot] = useState(false)
    const [error, setError] = useState(false)
    const [errorText, setErrorText] = useState("")
    const [failedCounter, setFailedCounter] = useState(0)

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        if (params.get('idle') === '1' || localStorage.getItem('optima_idle_expired') === '1') {
            setError(true)
            setErrorText("Your session has expired. Please log in again.")
            localStorage.removeItem('optima_idle_expired')
        }
        setVisible(true)
    }, [])

    const login = async event=>{
        setError(false)
        loader(true)
        event.preventDefault()
        const form = event.target
        const data = new FormData(form)
        data.set("rememberMe", false)
        const result = await fetch(form.action, {
            method: "POST",
            body: data,
            credentials: "include"
        })
        loader(false)
        if (result.status === 200) {
            location = result.url || endpoint
        } else {
            setFailedCounter(prev=>prev + 1)
            setError(true)
            setErrorText(result.status === 403? "You are locked out, try again in 30 minutes":"Failed to log you in with provided credentials")
        }
        return false
    }

    const reCaptchaOnChange = ()=>{
        setFailedCounter(0)
    }

    return <Container textAlign="center">
        <div style={{marginTop: 50}}></div>
        <Transition animation="drop" duration={1000} visible={visible}>
            <Image centered size='small' src={Images.logo} />
        </Transition>
        <div style={{ width: 500, marginLeft: "auto", marginRight: "auto", marginTop: 40, textAlign: "left" }}>
            {forgot?<Panel header={text("PasswordReset")} >
                <Form action={`${endpoint}Organization/Account/ForgotPassword`} method="POST">
                    <Form.Input name="username" label={text("Username")} iconPosition='left'></Form.Input>
                    <Button type='submit' primary>{text("Reset")}</Button>
                    <Button onClick={()=>setForgot(false)}>{text("Back")}</Button>
                </Form>
            </Panel>:<Panel header={text("SignIn")} >
                <Form error={error} action={`${endpoint}Organization/Account/Login`} onSubmit={login} method="POST" autoComplete="off">
                    <Form.Input name="username" placeholder={text("Username")} icon='at' iconPosition='left'></Form.Input>
                    <PasswordInput name="password" placeholder={text("Password")} icon='key' iconPosition='left' autoComplete="new-password" />
                    <Form.Field>
                        <Label as='a' basic onClick={()=>setForgot(true)}>{text("ForgotYourPassword")}</Label>
                    </Form.Field>
                    {failedCounter > 2 && <ReCAPTCHA sitekey="6LdN-SUTAAAAAD7uchl07G7yjbZVcM8A_c2vAIDO" onChange={reCaptchaOnChange}/>}
                    <Message
                    error
                    header='Failed to login'
                    content={errorText}
                    />
                    <Button type='submit' disabled={failedCounter > 2} primary>{text("SignIn")}</Button>
                </Form>
            </Panel>}
        </div>
    </Container>
}
